/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Toast_LinkInputs */

const en_signin_toast_link = /** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No link was sent.`)
};

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const ar_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const he_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const ur_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const es_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const fr_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const de_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const pt_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const hi_signin_toast_link = en_signin_toast_link;

/** @type {(inputs: Signin_Toast_LinkInputs) => LocalizedString} */
const bn_signin_toast_link = en_signin_toast_link;

/**
* | output |
* | --- |
* | "No link was sent." |
*
* @param {Signin_Toast_LinkInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_toast_link = /** @type {((inputs?: Signin_Toast_LinkInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Toast_LinkInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_toast_link(inputs)
	if (locale === "he") return he_signin_toast_link(inputs)
	if (locale === "ur") return ur_signin_toast_link(inputs)
	if (locale === "es") return es_signin_toast_link(inputs)
	if (locale === "fr") return fr_signin_toast_link(inputs)
	if (locale === "de") return de_signin_toast_link(inputs)
	if (locale === "pt") return pt_signin_toast_link(inputs)
	if (locale === "hi") return hi_signin_toast_link(inputs)
	if (locale === "bn") return bn_signin_toast_link(inputs)
	return /** @type {LocalizedString} */ ("No link was sent.")
});